// extracted by mini-css-extract-plugin
module.exports = {"addon_container":"styles_addon_container__2ECvR"};